const imageLoadCache = new Map();

function preloadImage(src) {

    if (!src) {

        return Promise.resolve('');

    }

    if (imageLoadCache.has(src)) {

        return imageLoadCache.get(src);

    }

    const image = new Image();

    const promise = new Promise(resolve => {

        image.addEventListener('load', () => resolve(src), { once: true });
        image.addEventListener('error', () => resolve(''), { once: true });
        image.src = src;

        if (image.complete) {

            resolve(image.naturalWidth > 0 ? src : '');

        }

    });

    imageLoadCache.set(src, promise);

    return promise;

}

function getBackgroundValue(src) {

    return src ? `url("${src}")` : '';

}

export function initNavPreviewer() {

    const previewer = document.querySelector('.main-nav .img-previewer');

    if (!previewer) {

        return;

    }

    const baseLayer = previewer.querySelector('.img-layer.--base');
    const overlayLayer = previewer.querySelector('.img-layer.--overlay');

    if (!baseLayer || !overlayLayer) {

        return;

    }

    const firstItemSrc = document.querySelector('.main-nav .submenu li[data-img-src]')?.dataset.imgSrc || '';
    const currentHeaderSrc = previewer.dataset.currentImgSrc || '';
    const fallbackDefaultSrc = previewer.dataset.defaultImgSrc || '';
    const defaultSrc = currentHeaderSrc || fallbackDefaultSrc || firstItemSrc || '';
    const items = [...document.querySelectorAll('.main-nav .submenu li[data-img-src]')];

    let currentSrc = defaultSrc || firstItemSrc || '';
    let pendingSrc = null;
    let transitionToken = 0;

    const getTransitionDuration = () => {

        const { transitionDuration } = window.getComputedStyle(overlayLayer);
        const firstValue = transitionDuration.split(',')[0]?.trim() || '0s';

        if (firstValue.endsWith('ms')) {

            return parseFloat(firstValue);

        }

        if (firstValue.endsWith('s')) {

            return parseFloat(firstValue) * 1000;

        }

        return 0;

    };

    const commitCurrentVisualState = () => {

        if (!previewer.classList.contains('is-transitioning')) {

            return;

        }

        const overlayImage = overlayLayer.style.backgroundImage;

        if (overlayImage) {

            baseLayer.style.backgroundImage = overlayImage;
            currentSrc = pendingSrc || currentSrc;

        }

        previewer.classList.remove('is-transitioning');
        overlayLayer.style.backgroundImage = '';
        pendingSrc = null;

    };

    const setPreview = async src => {

        const nextSrc = src || defaultSrc || fallbackDefaultSrc || currentSrc;

        if (nextSrc === pendingSrc || (nextSrc === currentSrc && !previewer.classList.contains('is-transitioning'))) {

            return;

        }

        commitCurrentVisualState();

        pendingSrc = nextSrc;
        transitionToken += 1;

        const token = transitionToken;
        const loadedSrc = await preloadImage(nextSrc);

        if (token !== transitionToken) {

            return;

        }

        if (!loadedSrc) {

            pendingSrc = null;
            return;

        }

        overlayLayer.style.backgroundImage = getBackgroundValue(loadedSrc);

        requestAnimationFrame(() => {

            previewer.classList.add('is-transitioning');

        });

        window.setTimeout(() => {

            if (token !== transitionToken) {

                return;

            }

            baseLayer.style.backgroundImage = getBackgroundValue(loadedSrc);
            currentSrc = loadedSrc;

            previewer.classList.remove('is-transitioning');
            overlayLayer.style.backgroundImage = '';
            pendingSrc = null;

        }, Math.max(getTransitionDuration(), 100));

    };

    baseLayer.style.backgroundImage = getBackgroundValue(currentSrc);

    preloadImage(currentHeaderSrc);
    preloadImage(defaultSrc);
    preloadImage(fallbackDefaultSrc);

    items.forEach(item => {

        const src = item.dataset.imgSrc || '';

        preloadImage(src);

        item.addEventListener('mouseenter', () => {

            setPreview(src);

        });

        item.addEventListener('focusin', () => {

            setPreview(src);

        });

        item.addEventListener('mouseleave', () => {

            setPreview(defaultSrc);

        });

        item.addEventListener('focusout', event => {

            if (item.contains(event.relatedTarget)) {

                return;

            }

            setPreview(defaultSrc);

        });

    });

}
